import { toDateTimeLocal } from '../dateTime';
import {
  asString,
  isKnownValue,
  parseEnabledRegionsField,
  parseObject,
  parseOptionalObjectField,
  parseRequiredArrayField,
} from '../parseHelpers';

import { createCardDraftLabel } from './cards';
import { createDefaultCard } from './defaults';
import { fieldLabel } from './fieldLabels';
import type { WhatsNewCarouselCard, WhatsNewCarouselPayloadBuilderState } from './types';
import { WHATS_NEW_CAROUSEL_IMAGE_FIT_OPTIONS } from './types';

function parseImageOptionsFit(source: Record<string, unknown>, label: string): WhatsNewCarouselCard['imageOptionsFit'] {
  const imageOptions = parseOptionalObjectField(source, 'imageOptions');
  const fit = asString(imageOptions.fit);

  if (!fit) {
    return '';
  }

  if (isKnownValue(fit, WHATS_NEW_CAROUSEL_IMAGE_FIT_OPTIONS)) {
    return fit;
  }

  throw new Error(`${label} imageOptions.fit must be ${WHATS_NEW_CAROUSEL_IMAGE_FIT_OPTIONS.join(' or ')}`);
}

function parseCard(value: unknown, index: number): WhatsNewCarouselCard {
  const label = `Card ${index + 1}`;
  const source = parseObject(value, label);
  const defaults = createDefaultCard(createCardDraftLabel(index));

  return {
    ...defaults,
    isActive: source.isActive === undefined ? defaults.isActive : source.isActive === true,
    enabledRegions: parseEnabledRegionsField(source, `${label} ${fieldLabel('enabledRegions')}`),
    startAt: toDateTimeLocal(source.startAt),
    endAt: toDateTimeLocal(source.endAt),
    imageId: asString(source.imageId),
    imageOptionsFit: parseImageOptionsFit(source, label),
    overline: asString(source['overline-i18n']),
    title: asString(source['title-i18n']),
    description: asString(source['description-i18n']),
    ctaLabel: asString(source['ctaLabel-i18n']),
    ctaUrl: asString(source.ctaUrl),
    openInNewTab: source.openInNewTab === undefined ? defaults.openInNewTab : source.openInNewTab === true,
    optimizelyFeatureFlag: asString(source.optimizelyFeatureFlag),
  };
}

export function parseWhatsNewCarouselPayload(value: unknown): WhatsNewCarouselPayloadBuilderState {
  const source = parseObject(value, 'Payload');
  const cards = parseRequiredArrayField(source, 'cards').map((card, index) => parseCard(card, index));

  return {
    mode: 'whatsNewCarousel',
    cards,
  };
}
